import { API_ROUTES_FOR_AXIOS } from 'src/constants/ApiRoutes';
import { axiosInstance } from 'src/constants/axiosInstance';
import {
  BrainMemoryCountLevel,
  BrainMemoryCountResponse,
  MemoryRelation,
} from 'src/types/brainMemory';
import { ApiResponse } from 'src/types/commonResponseTypes';
import { handleError } from 'src/utils/commonErrorUtils';

export const deleteOrgAutoIngestedMemories = async (): Promise<
  ApiResponse<string>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['deleteAllAutoMemoryIngestion']();

    const { data } = await axiosInstance.delete(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const deleteUserAutoIngestedMemories = async (
  userId: string,
): Promise<ApiResponse<string>> => {
  try {
    const apiUrl =
      API_ROUTES_FOR_AXIOS['deleteUserAllAutoMemoryIngestion'](userId);

    const { data } = await axiosInstance.delete(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getAutoIngestedMemoriesCount = async (
  level: BrainMemoryCountLevel,
): Promise<ApiResponse<BrainMemoryCountResponse>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['countBrainMemories'](level);

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getOrgGraphBrainMemories = async (): Promise<
  ApiResponse<MemoryRelation[]>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getOrgGraphBrainMemories']();

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
